import {Module} from 'vuex';
import {RootState} from '@/types';
import {namespace} from 'vuex-class';
import EducationApi from '@/api/EducationApi';
import {
  SET_EDUCARION,
  SET_EDUCARIONS,
  SET_LOCATION,
  SET_INSTITUTION,
  SET_SKILLS,
} from '@/store/mutationTypes';

export const educationModule = namespace('education');
export interface Education {
  [key: string]: any;
}

interface EducationState {
  educations: Education[];
  education: Education | null;
  institution: Education[];
  location: Education | null;
  skills: Education[];
}
export default <Module<EducationState, RootState>>{
  namespaced: true,
  state: {
    educations: [],
    education: null,
    location: null,
    institution: [],
    skills: [],
  },
  mutations: {
    [SET_EDUCARIONS](state, data) {
      state.educations = data;
    },
    [SET_EDUCARION](state, data) {
      state.education = data;
    },
    [SET_LOCATION](state, data) {
      state.location = data;
    },
    [SET_INSTITUTION](state, data) {
      state.institution = data;
    },
    [SET_SKILLS](state, data) {
      state.skills = data;
    },
  },
  actions: {
    async getEducation({commit}, params = {}) {
      try {
        const {data} = await EducationApi.getEducation(params);
        commit(SET_EDUCARIONS, data.data);
        return data;
      } catch (e) {
        return e.response.data;
      }
    },
    async getSkills({commit}, params = {}) {
      try {
        const {data} = await EducationApi.getSkills(params);
        commit(SET_SKILLS, data.data);
        return data;
      } catch (e) {
        return e.response.data;
      }
    },
    async getDetailEducation({commit}, id) {
      try {
        const {data} = await EducationApi.getDetailEducation(id);
        commit(SET_EDUCARIONS, data.data);
        return data;
      } catch (e) {
        return e.response.data;
      }
    },
    async updateEducation(_, {payload, id}) {
      try {
        const data = await EducationApi.updateEducation(payload, id);
        return data;
      } catch (e) {
        return e.response.data;
      }
    },
    async createEducation(_, payload) {
      try {
        const data = await EducationApi.createEducation(payload);
        return data;
      } catch (e) {
        return e.response.data;
      }
    },
    async getInstution({commit}, params = {}) {
      try {
        const {data} = await EducationApi.getInstution(params);
        commit(SET_INSTITUTION, data.data);
        return data;
      } catch (e) {
        return e.response.data;
      }
    },
    async delete(_, id) {
      try {
        const {data} = await EducationApi.delete(id);
        return data;
      } catch (e) {
        return e.response.data;
      }
    },
  },
};
